import script from "./QuickMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickMenu.vue?vue&type=script&setup=true&lang=js"

import "./QuickMenu.vue?vue&type=style&index=0&id=02636d07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02636d07"]])

export default __exports__